import { render, staticRenderFns } from "./CollectionTeaserSection.vue?vue&type=template&id=ac4be9ec&"
import script from "./CollectionTeaserSection.vue?vue&type=script&lang=js&"
export * from "./CollectionTeaserSection.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTeaserSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports